// reducers/NoteReducer.js
import {
    CONFIRMED_GET_NOTES,
    CONFIRMED_CREATE_NOTE_ACTION,
    CONFIRMED_SEND_DOCTOR_NOTE_REPLY
  } from "../actions/NoteTypes";
  
  const initialState = {
    notes: [],
  };
  
  export default function NoteReducer(state = initialState, action) {
    if (action.type === CONFIRMED_GET_NOTES) {
      return {
        ...state,
        notes: action.payload,
      };
    }
  
    if (action.type === CONFIRMED_CREATE_NOTE_ACTION) {
      const notes = [...state.notes];
      notes.push(action.payload);
  
      return {
        ...state,
        notes,
      };
    }
     
    if (action.type === CONFIRMED_SEND_DOCTOR_NOTE_REPLY) {
      const updatedNotes = state.notes.map((note) =>
        note.id === action.payload.note_id
          ? { ...note, reply: action.payload.reply }
          : note
      );
  
      return {
        ...state,
        notes: updatedNotes,
      };
    }
    return state;
  }
  